













































































































































import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import { State, Action, namespace } from "vuex-class";
const accountManage = namespace("accountManage");
import { getStore } from "../../../../../utils/utils";
import { PasswaordContent } from "@/components";
const reimbursement = namespace("reimbursement");
import { toDecimalFN } from "@/utils/filter";
import md5 from "md5";
@Component({
  name: "immediatPayment",
  components: {
    PasswaordContent,
  },
})
export default class immediatPayment extends Vue {
  @accountManage.Action bankListFN: any;
  @accountManage.State bankList: any;
  @reimbursement.Action queryPay;
  @Prop() payFlag;
  @Prop() data; // billNo  loanAmt  reduAmt  billMonth  sminAmt  rminAmt  minFlag
  showPicker: boolean = false;
  showBankList: Array<string> = [];
  praData: any = {}; // 参数
  totalAmount: any = 0; //总金额
  vShow: any = true; // 修改金额 展示与否
  errorMessage: any = ""; // 错误信息
  componentShow: any = false; // 付款框展示控制
  radio: any = "1";
  accNo: any = ""; // 银行卡号
  lowertotalAmount: any = 0;
  remainMoney: any = 0; // 剩余应还
  created() {
    this.data.loanAmt = toDecimalFN(this.data.loanAmt - 0);
    this.bankListFN({
      custId: getStore("userInfo")
        ? JSON.parse(getStore("userInfo")).custId
        : "",
    });
    this.totalAmount = toDecimalFN(this.data.loanAmt - 0);
    this.lowertotalAmount = toDecimalFN(this.data.sminAmt - this.data.rminAmt); // 应还最小-实还最小
    this.remainMoney = this.$money(
      this.data.loanAmt - (this.data.sminAmt - this.data.rminAmt)
    ); // 剩余应还
  }
  // 修改金额点击
  updateClick(val, type) {
    if (this.radio == 2) {
      return false;
    }
    this.vShow = type;
    if (val == "all") {
      this.totalAmount = this.data.loanAmt;
    } else {
      this.$refs["totalAmount"]["focus"]();
    }
  }
  checkTotalAmount() {
    let needPay = this.data.loanAmt;
    let willPay = this.totalAmount;
    //输入金额为空，不做处理
    if (this.totalAmount == "") {
      this.errorMessage = "";
      return false;
    }
    // 输入金额 > 待还款
    if (willPay > needPay) {
      this.errorMessage = `最高可还款${this.data.loanAmt}元`;
      return false;
    }
    // 待还款 > 1
    if (needPay > 1) {
      if (willPay < 1) {
        this.errorMessage = "还款金额不能低于1元";
        return false;
      }
      // 待还款总金额 < 1
    } else {
      if (willPay < needPay) {
        this.errorMessage = "剩余待还金额不足1元，请全部还款";
        return false;
      }
    }
    this.errorMessage = "";
    return true;
  }

  onCancel() {
    this.componentShow = false;
  }
  handleShowPicker() {
    this.showPicker = true;

    this.$nextTick(() => {
      const ele: any = this.$refs.picker;
      ele.setValues([this.accNo]);
    });
  }

  @Watch("bankList", { immediate: true })
  onchanged(val: any) {
    this.showBankList = [];
    for (var i = 0, len = val.length; i < len; i++) {
      let accNo = val[i]["accNo"];
      let strNum = accNo.substr(accNo.length - 4);
      let newAccNo = `${strNum}(${val[i]["bankName"]})`;
      val[i]["showAccNo"] = newAccNo;
      this.showBankList.push(val[i]["showAccNo"]);
      if (val[i]["isDefault"] == "01") {
        this.accNo = val[i]["showAccNo"];
      }
    }
  }
  onFocus() {
    this.vShow = false;
  }
  onBlur() {
    if (!this.totalAmount) {
      this.updateClick("all", true);
    } else {
      this.vShow = true;
    }
  }
  onConfirm(value) {
    this.showPicker = false;
    this.accNo = value;
  }
  //确认按钮
  buttonClick(type) {
    this.componentShow = true;
  }

  // 处理银行卡号转换
  changeAccNo(str: string, data: Array<string>) {
    let strSplit = str.split("(")[0];
    let newStr = "";
    for (var i = 0, len = data.length; i < len; i++) {
      if (data[i]["accNo"].indexOf(strSplit) !== -1) {
        newStr = data[i]["accNo"];
      }
    }
    return newStr;
  }
  //radio点击
  radioChange(name) {}
  //确认还款方法
  confirmClick(val) {
    if (val && val.length == 6) {
      let accNo1 = this.changeAccNo(this.accNo, this.bankList);
      // 已进行最低额还款-1
      //   let aParams = {
      //     retuKind: this.data.accStat == '03' ? 1 : 0, // 还款方式  03:逾期
      //     accNo: accNo1, // 银行卡号
      //     amt: this.totalAmount, // 金额
      //     billNo: this.data.billNo, // 账单号
      //     custId: JSON.parse(getStore('userInfo')).custId || '', // 客户编号
      //     passWord: md5(val) //支付密码
      //   }
      //未进行最低额还款 -0
      //   let nParams = {
      //     retuKind: this.data.accStat == '03' ? 1 : 0, // 还款方式  03:逾期
      //     accNo: accNo1, // 银行卡号
      //     amt: this.radio == 1 ? this.totalAmount : this.lowertotalAmount, // 金额
      //     billNo: this.data.billNo, // 账单号
      //     custId: JSON.parse(getStore('userInfo')).custId || '', // 客户编号
      //     passWord: md5(val) //支付密码
      //   }

      let aParam = {
        // 还款方式  03:逾期  1:主动单笔逾期 0：主动单笔正常  6：最小额还款
        retuKind: this.data.accStat == "03" ? 1 : this.radio == 1 ? 0 : 6,
        accNo: accNo1, // 银行卡号
        amt: this.radio == 1 ? this.totalAmount : this.lowertotalAmount, // 金额
        billNo: this.data.billNo, // 账单号
        custId: getStore("userInfo")
          ? JSON.parse(getStore("userInfo")).custId
          : "", // 客户编号
        passWord: md5(val), //支付密码
      };
      this.$toast.loading({
        message: "正在支付",
        duration: 0,
        forbidClick: true,
      });
      this.queryPay(aParam).then((res) => {
        if (res["code"] == 200) {
          this.$toast.clear();
          this.onCancel();
          this.$router.replace({
            path: "/reimbursementConfirm/paymentResult",
            query: {
              status: "success",
              text: res.msg,
              billMonth: res.data.billMonth,
            },
          });
        } else if (res["code"] == 400) {
          this.$toast.clear();
          this.onCancel();
          this.$toast.fail(res.msg);
        } else {
          this.$toast.clear();
          this.onCancel();
          this.$router.replace({
            path: "/reimbursementConfirm/paymentResult",
            query: {
              status: "error",
              text: res.msg,
              billMonth: res.data.billMonth,
            },
          });
        }
      });
    }
  }

  // 格式化输入内容
  formatter(value) {
    let str = value;
    let len1 = str.substr(0, 1);
    let len2 = str.substr(1, 1);
    //如果第一位是0，第二位不是点，就用数字把点替换掉
    if (str.length > 1 && len1 == 0 && len2 != ".") {
      str = str.substr(1, 1);
    }
    //第一位不能是.
    if (len1 == ".") {
      str = "";
    }
    //限制只能输入一个小数点
    if (str.indexOf(".") != -1) {
      let str_ = str.substr(str.indexOf(".") + 1);
      if (str_.indexOf(".") != -1) {
        str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1);
      }
      if (str_.length > 2) {
        //   this.$message.warning(`金额小数点后只能输入两位，请正确输入！`);
        str = str.substr(0, str.indexOf(".") + 3);
        return str;
      }
    }
    //正则替换
    str = str.replace(/[^\d^\.]+/g, ""); // 保留数字和小数点
    return str;
  }
}
